<div class="global-research" [style.height.px]="boxHeight()">
	<div class="global-research-chrome" #chrome>
		<div class="search-row disp-f a-i-c gap-S">
			@if (layout.isHandset()) {
				<!-- Plein écran : pas de fond cliquable pour fermer — la flèche retour remplace la loupe (Material search view). -->
				<button type="button" class="back-button radius-M flex-center border-grey-XS pointer" (click)="close()"
				        [attr.aria-label]="'global.research.close' | translate" [title]="'global.research.close' | translate">
					<img src="assets/icons/arrow-left.svg" width="14" height="14" alt="" class="filter-darkgrey">
				</button>
			} @else {
				<div class="radius-M flex-center border-grey-XS" style="width: 40px; height: 40px; background: #B5B5C31A">
					<img [ngSrc]="icons.search" width="20" height="20" alt="" class="search-icon">
				</div>
			}
			<input
				type="text"
				class="search-input font-M"
				maxlength="100"
				[formControl]="searchControl"
				[placeholder]="'global.research.placeholder' | translate">
			@if (store.loading()) {
				<app-spinner color="grey" [scale]="0.5"/>
			} @else if (store.query()) {
				<button type="button" class="flex-center clear-button pointer" (click)="clearSearch()">
					<img [ngSrc]="icons.clear" width="16" height="16" alt="" class="clear-icon">
				</button>
			}
		</div>
		<span class="separation"></span>
		<div class="filters-row pad-M-0 pad-0-L flex a-i-c j-c-sb gap-S">
			<div class="flex a-i-c gap-S">
				<button type="button" class="filter-box flex a-i-c gap-S c-p" style="min-width: 90px;"
				        [class.selected]="store.isAllSelected()"
				        (click)="store.selectAllTypes()">
					<img [src]="icons.all" height="14" width="14" alt="" class="filter-color" [class.selected]="store.isAllSelected()">
					<span class="font-M fw-600 filter-text" [class.selected]="store.isAllSelected()">{{ 'global.research.all' | translate }}</span>
				</button>
				@for (filter of store.visibleFilterTypes(); track filter) {
					<button type="button" class="filter-box flex a-i-c gap-S c-p"
					        [class.selected]="store.selectedTypes().includes(filter)"
					        (click)="store.toggleType(filter)">
						<img [src]="filterIcon(filter)" height="14" width="14" alt="" class="filter-color" [class.selected]="store.selectedTypes().includes(filter)">
						<span class="font-M fw-600 filter-text" [class.selected]="store.selectedTypes().includes(filter)">{{ 'global.research.sections.' + filter | translate }}</span>
					</button>
				}
			</div>

			@if (store.overflowFilterTypes().length > 0) {
				<button type="button" class="filter-box flex a-i-c gap-S c-p" [matMenuTriggerFor]="menu">
					<img [src]="icons.seeMore" height="14" width="14" alt="" class="filter-color">
					<span class="font-M fw-600 filter-text">{{ 'menu.seeMore' | translate}}</span>
				</button>
			}
			<mat-menu #menu class="global-research-filter-menu" xPosition="before" yPosition="below">
				@for (filter of store.overflowFilterTypes(); track filter) {
					<button type="button" class="menu-element flex a-i-c gap-S c-p"
					        [class.selected]="store.selectedTypes().includes(filter)"
					        (click)="store.toggleType(filter)">
						<img [src]="filterIcon(filter)" height="14" width="14" alt="" class="filter-color" [class.selected]="store.selectedTypes().includes(filter)">
						<span class="font-M fw-600 filter-text" [class.selected]="store.selectedTypes().includes(filter)">{{ 'global.research.sections.' + filter | translate }}</span>
					</button>
				}
			</mat-menu>
		</div>
	</div>

	@if (store.error(); as error) {
		<div #measuredContent>
			<app-error-state size="block" [error]="error" (retry)="store.retrySearch()"></app-error-state>
		</div>
	} @else if (store.result()) {
		<overlay-scrollbars class="results-scroll-host" [options]="resultsScrollOptions">
			<div class="results disp-f flex-column gap-S" #measuredContent>
				@if (store.sections().length > 0) {
					@for (section of store.sections(); track section.type) {
						<div class="section disp-f flex-column">
							<div class="section-header disp-f a-i-c gap-XS">
								<span class="font-M fw-600 grey">{{ 'global.research.sections.' + section.type | translate }}</span>
							</div>
							@for (item of section.items; track item.id) {
								<ng-container *ngTemplateOutlet="resultItem; context: {$implicit: item}"/>
							}
						</div>
					}
				} @else if (!store.loading()) {
					<div class="pad-L flex-center font-M grey text-center" style="height: 230px;">
						{{ 'global.research.noResult' | translate: {query: store.query()} }}
					</div>
				}
			</div>
		</overlay-scrollbars>
	} @else if (store.suggestionsLoading()) {
		<div class="suggestions-loading flex-center pad-L" #measuredContent>
			<app-dashboard-page-loader [height]="270" class="suggestions-loader"></app-dashboard-page-loader>
		</div>
	} @else if (store.suggestionsError(); as error) {
		<div class="pad-L" #measuredContent>
			<app-error-state size="compact" [error]="error" (retry)="store.loadSuggestions()"></app-error-state>
		</div>
	} @else if (store.visibleSuggestions().length > 0) {
		<overlay-scrollbars class="results-scroll-host" [options]="resultsScrollOptions">
			<!-- The header lives inside #measuredContent so boxHeight accounts for it — outside, the
			     scroll host overflows by the header's height and shows a needless scrollbar. -->
			<div class="results disp-f flex-column gap-S" #measuredContent>
				<span class="font-M fw-600 grey pad-0-M">{{ 'global.research.suggestions'| translate }}</span>
				<div class="section disp-f flex-column">
					@for (item of store.visibleSuggestions(); track item.type + item.id) {
						<ng-container *ngTemplateOutlet="resultItem; context: {$implicit: item}"/>
					}
				</div>
			</div>
		</overlay-scrollbars>
	} @else {
		<div class="pad-L flex-center font-M grey text-center" style="height: 230px" #measuredContent>
			{{ 'global.research.noData' | translate }}
		</div>
	}
</div>

<ng-template #resultItem let-item>
	<button type="button" class="result-item flex j-c-sb a-i-c gap-S c-p" (click)="select(item)">
		<div class="result-main flex j-c-c a-i-c gap-S">
			@if (item.type === SearchEntityType.APPLICATION) {
				<app-display-logo [logo]="item.icon" [size]="38"></app-display-logo>
			} @else if (item.type === SearchEntityType.SERVER) {
				<div class="server-icon flex-center p-relative">
					<img width="18" [src]="itemIcon(item)" class="filter-accent" alt="">
					@if (serverStatus(item) === DataCollectionStatus.ACTIVE) {
						<div class="p-absolute server-status-bg flex-center">
							<div class="server-status-bubble server-status-bubble-success"></div>
						</div>
					} @else if (serverStatus(item) === DataCollectionStatus.OUTDATED) {
						<div class="p-absolute server-status-bg flex-center">
							<div class="server-status-bubble server-status-bubble-warning"></div>
						</div>
					} @else {
						<div class="p-absolute server-status-bg flex-center">
							<div class="server-status-bubble server-status-bubble-unknown"></div>
						</div>
					}
				</div>
			} @else if (item.type === SearchEntityType.ORGANIZATION) {
				<div class="flex-center radius-M" style="width: 38px; height: 38px; background: #3DC0FF1A">
					<img [src]="'/assets/icons/team_icon/'+ item.icon +'.svg'" alt="" class="filter-accent">
				</div>
			} @else {
				<div class="flex-center radius-M" style="width: 38px; height: 38px; background: #3DC0FF1A">
					<img [src]="itemIcon(item)" alt="" class="filter-accent">
				</div>
			}
			<div class="result-text flex-column gap-5" style="max-width: 500px;">
				<span class="font-M fw-700 primary text-overflow-ellipsis">{{ item.name }}</span>
				<span class="font-S fw-500 grey text-overflow-ellipsis">{{ item.description ?? "-" }}</span>
			</div>
		</div>
		<div>
			<img [ngSrc]="icons.arrowRight" width="10" height="10" alt="">
		</div>
	</button>
</ng-template>
